"use strict";var ddWithoutApi=require("./entry/union"),apiObj_1=require("./api/apiObj"),plugin=require("./plugin"),dd=Object.assign(ddWithoutApi,apiObj_1.apiObj,{plugin:plugin});module.exports=dd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/index.js
// module id = hyIN
// module chunks = 0